import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import React, { Component } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import EventBus from "../common/EventBus.js"
import GlobalHelper from "../common/GlobalHelper.jsx"
import Checkbox from "../common/checkbox/checkbox.component.jsx"
import ItemBulkDiscountComponent from "../common/quote/component/ItemBulkDiscountComponent.tsx"
import ItemBulkUpdateComponent from "../common/quote/component/ItemBulkUpdateComponent.tsx"
import { isError } from "../state/helpers/Error"
import {
    patchPricingTable, setInitialState,
    setPricingTableSelectedItems,
} from '../state/pricing/actions'
import RowCustomStatusService from "../state/pricing/rowcustomstatus/RowCustomStatusService"
import {
    getMainItems,
    getPricingTableGroups,
    getPricingTableItems,
    getPricingTableSelectedItems
} from '../state/pricing/selectors'
import { PRODUCT_TYPE } from "../state/product/Types"
import { isBundle } from "../utils"
import { PRICING_TABLES } from "../utils/pricing/constants"
import PricingTableItemWrapper from "./PricingTableItemWrapper"
import PricingTableGroup from './components/PricingTableGroupComponent'

class PricingTableContent extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDropDisabled: {},
            groupsDropClassName: '',
            productDescription: 'long',
            isGroupsDropDisabled: false,
            isMainDropDisabled: false,
            sortable: this.props.sortable === true,
            allItems:this.props.items,
            items: this.props.items.filter(i => i?.attributes.parentId === ""),
            users: [],
            allowEdit: this.props.allowEdit,
            showInventoryDetails: this.props.showInventoryDetails || false,
            location: this.props.location || null,
            documentCalendarEvents: [],
            itemSelection: this.props.itemSelection || new Set(),
            itemList: new Set(this.props.items.filter(i => i?.attributes.parentId === "").map(item => item.id)),
            currency: this.props.currency,
            rowCustomStatuses: [],
            main: this.props.main,
            stockDocument: this.props.stockDocument || null,
            documentStatus: this.props.documentStatus || "",
        }
        this.onUpdateCallback = this.props.onUpdate || function () { }
        this.onDragEnd = this.onDragEnd.bind(this)
        this.findAdviceByItemId = this.findAdviceByItemId.bind(this)
        this.triggerSelectAll = this.triggerSelectAll.bind(this)
        this.onDragStart = this.onDragStart.bind(this)
        this.loadCalendarEvents = this.loadCalendarEvents.bind(this)
        this.refreshCalendarEvents = this.refreshCalendarEvents.bind(this)
        this.onBulkUpdateChange = this.onBulkUpdateChange.bind(this)
        this.selectionContainsBundleItem = this.selectionContainsBundleItem.bind(this)
        for (let index in this.props.groups) {
            const group = this.props.groups[index]
            this.state[group.id] = this.state.items.filter(i => i.attributes.groupId === group.id && i?.attributes.parentId === "")
            this.state.isDropDisabled[group.id] = false
        }
        EventBus.listen(EventBus.TopicDocumentCalendarEventsRefreshed, 'quote-item-list', this.refreshCalendarEvents)
    }


    getType() {
        return this.props.mainObject.slice(0, -1)
    }
    
    componentDidMount() {

        AppContext.getApiClient().get('/users/' + AppContext.getUserLoggedIn().id + '/preferences').then(res => {
            this.setState({
                productDescription: res.attributes.productDescription || this.state.productDescription,
            })
        })

        AppContext.getApiClient().get('/users').then(res => {
            this.setState({
                users: res.data,
            })
        })

        if (this.props.mainObject === 'orders') {
            RowCustomStatusService.GetAll().then(res => {
                if (!isError(res))
                    this.setState({
                        rowCustomStatuses: res,
                    })
            })
        }
        this.loadCalendarEvents()
    }

    componentWillUnmount() {
        EventBus.unsubscribe(EventBus.TopicDocumentCalendarEventsRefreshed, 'quote-item-list')
        if (!this.props.persistState) {
            this.props.dispatch(setInitialState())
        }
    }

    componentWillReceiveProps ( nextProps ) {
        let state = {
            stockDocument:nextProps.stockDocument || null,
            mainObject: nextProps.mainObject || '',
            itemSelection: nextProps.itemSelection || new Set(),
            items: nextProps.items.filter(i => i?.attributes.parentId==""),
            allItems: nextProps.items || [],
            allowEdit: nextProps.allowEdit,
            location: nextProps.location || null,
            itemList: new Set(nextProps.items.filter(i => i?.attributes.parentId=="").map(item => item.id)),
            main: nextProps.main,
            documentStatus: nextProps.documentStatus || ""
        }
        state.isDropDisabled = {}
        for (let index in nextProps.groups) {
            const group = nextProps.groups[index]
            state[group.id] = nextProps.items.filter(i => i.attributes.groupId === group.id && i?.attributes.parentId === "")
            state.isDropDisabled[group.id] = false
        }
        this.setState(state)
    }

    refreshCalendarEvents(calendarEvents) {
        this.setState({
            documentCalendarEvents: calendarEvents.getData() || [],
        })
    }

    loadCalendarEvents() {
        if (this.props.mainObject === 'price-lists' || !this.props.projectId) {
            return
        }
        const endPoint = `/projects/${this.props.projectId}/calendar-events`

        AppContext.getApiClient().get(endPoint).then(res => {
            this.setState({
                documentCalendarEvents: res.data,
            })
        })
    }

    findAdviceByItemId(itemId) {
        const advices = this.props.advices || []
        const usableAdvices = advices.filter(advice =>
            (advice.attributes.itemId === itemId) &&
            advice.attributes.type === "incompatible"
        )
        if (usableAdvices.length) {
            return usableAdvices[0]
        } else {
            return null
        }
    }

    reorder(list, startIndex, endIndex) {
        const result = Array.from(list)
        const [removed] = result.splice(startIndex, 1)
        result.splice(endIndex, 0, removed)

        return result
    }

    move(source, destination, droppableSource, droppableDestination) {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);

        destClone.splice(droppableDestination.index, 0, removed);

        const result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;

        return result;
    }

    triggerSelectAll(isChecked, groupId, groupItemIds) {
        let selection = this.state.itemSelection
        if (isChecked) {
            let itemList = this.state.itemList
            if (groupId) {
                itemList = groupItemIds
            }
            for (let i of itemList) {
                if (!selection.has(i)) {
                    selection.add(i)
                }
            }
        } else {
            if (!groupId) {
                selection.clear()
            } else {
                for (let i of groupItemIds) {
                    selection.delete(i)
                }
            }

        }

        this.props.dispatch(setPricingTableSelectedItems(selection, this.props.objectId))
    }

    isAllItemsChecked(groupId, groupItemSelectionSet) {
        if (!groupId) {
            return (this.state.itemSelection && this.state.itemSelection.size === this.state.itemList.size && this.state.itemList.size > 0)
        }

        return this.state.items
            .filter(item => item.attributes.groupId === groupId)
            .map(item => item.id).length === groupItemSelectionSet.size
    }

    isAtLeastOneItemChecked(groupId, selectedItemSelectionSet) {
        if (!groupId) {
            return this.state.itemSelection && this.state.itemSelection.size > 0
        }
        return selectedItemSelectionSet.size > 0
    }

    selectionContainsBundleItem() {
        let selection = this.state.itemSelection
        let bundleItems = this.state.items.filter(item => item.attributes.itemObject.attributes.type === PRODUCT_TYPE.BUNDLE)
        for (let item of bundleItems) {
            if (selection.has(item.id)) {
                return true
            }
        }
        return false
    }

    onDragStart(res) {
        if (res.source.droppableId === "groups") {
            const { isDropDisabled } = this.state
            for (let index in this.props.groups) {
                const group = this.props.groups[index]
                isDropDisabled[group.id] = true
            }
            this.setState({
                isDropDisabled: isDropDisabled,
                isGroupsDropDisabled: false,
                isMainDropDisabled: true,
                groupsDropClassName: 'dnd-highlight',
            })
            return
        }
        const groupId = res.source.droppableId
        const itemId = res.draggableId
        const item = this.state[groupId].filter(i => i.id === itemId)[0]
        const { isDropDisabled } = this.state
        for (let index in this.props.groups) {
            const group = this.props.groups[index]
            isDropDisabled[group.id] = !(!group.attributes.billingMethod || (item && group.attributes.billingMethod === item.attributes.billingMethod))
        }
        this.setState({
            isDropDisabled: isDropDisabled,
            isGroupsDropDisabled: true,
            isMainDropDisabled: false,
            groupsDropClassName: '',
        })

    }

    onDragEnd(result) {
        const { source, destination } = result;
        // dropped outside the list
        if (!destination) {
            return
        }

        const { isDropDisabled } = this.state
        for (let index in this.props.groups) {
            const group = this.props.groups[index]
            isDropDisabled[group.id] = false
        }

        if (source.droppableId === "groups") {
            const items = this.reorder(
                this.props.groups,
                source.index,
                destination.index
            ).map(i => {
                if (result.draggableId === i.id) {
                    i.attributes.rank = destination.index
                }
                return i
            })
            let state = {
                groupsDropClassName: '',
                isDropDisabled: isDropDisabled,
                isGroupsDropDisabled: true,
                isMainDropDisabled: false,
            }

            this.props.dispatch(patchPricingTable(
                this.props.mainObject,
                this.props.objectId,
                {
                    groupsOrder: items.map(i => i.id),
                })
            )

            this.setState(state)
            return
        }

        if (source.droppableId === destination.droppableId) {
            const items = this.reorder(
                this.state[source.droppableId],
                source.index,
                destination.index
            ).map(i => {
                if (result.draggableId === i.id) {
                    i.attributes.rank = destination.index
                }
                return i
            })
            let state = {
                isDropDisabled: isDropDisabled,
                isGroupsDropDisabled: true,
                isMainDropDisabled: false,
                groupsDropClassName: '',
                [source.droppableId]: items
            }

            if (source.droppableId === "main") {
                this.setState({ main: items })
            }
            this.props.dispatch(patchPricingTable(
                this.props.mainObject,
                this.props.objectId,
                {
                    rowsOrder: [state[source.droppableId].map(i => i.id)],
                })
            )
        } else {
            const move = this.move(
                this.state[source.droppableId],
                this.state[destination.droppableId],
                source,
                destination
            )
            const update = i => {
                if (result.draggableId === i.id) {
                    i.attributes.rank = destination.index
                    i.attributes.groupId = destination.droppableId
                }
                return i
            }

            move[source.droppableId].map(update)
            move[destination.droppableId].map(update)
            move.isDropDisabled = isDropDisabled
            move.isGroupsDropDisabled = true
            move.isMainDropDisabled = false
            move.groupsDropClassName = ''
            this.setState(move)

            const destinationGroupId = destination.droppableId === "main" ? "" : destination.droppableId
            this.props.dispatch(
                patchPricingTable(
                    this.props.mainObject,
                    this.props.objectId, 
                    {
                    rows: {
                        [result.draggableId]: {
                            groupId: destinationGroupId
                        },
                    },
                    rowsOrder: [
                        move[destination.droppableId].map(i => i.id),
                        move[source.droppableId].map(i => i.id),
                    ]
                }
            ))
        }
    }

    onBulkUpdateChange() {
        this.props.dispatch(setPricingTableSelectedItems([], this.props.objectId))
        this.props.onUpdate()
    }

    render() {
        const isPricingTable = this.props.mainObject === PRICING_TABLES
        const onUpdateCallback = this.props.onUpdate || function () { }
        const onEditLinkClickCallback = this.props.onEditLinkClick || function () { }
        const methods = GlobalHelper.unique(this.props.items.map(i => {
            return i.attributes.billingMethod
        }).concat(this.props.groups.map(g => {
            return g.attributes.billingMethod
        })))

        return (
            <div className={"" + this.props.groupsDropClassName}>
                {(this.props.allowEdit && this.state.itemList.size > 0) &&
                    <div className="sticky-top" style={{ zIndex: 1 }}>
                        <div className={"quote-item row py-2 d-flex align-items-center bg-light"}>
                            <Checkbox className={'mr-3'} title={'Select All'}
                                checked={this.isAtLeastOneItemChecked()}
                                isPartiallyChecked={(this.isAtLeastOneItemChecked() && !this.isAllItemsChecked())}
                                onChange={(isChecked) => {
                                    this.triggerSelectAll(isChecked)
                                }} />
                            <div className={"mr-2"}>
                                {this.isAtLeastOneItemChecked()  ?
                                    <div>
                                        <ItemBulkDiscountComponent
                                            objectId={this.props.objectId}
                                            itemIdList={this.state.itemSelection}
                                            currency={this.props.currency}
                                            onChange={onUpdateCallback}
                                            editable={true}
                                            title={'Discount '}
                                            type={this.getType()}
                                        />
                                        <ItemBulkUpdateComponent
                                            tableId={this.props.tableId}
                                            objectId={this.props.objectId}
                                            rowCustomStatuses={this.state.rowCustomStatuses}
                                            itemIdList={this.state.itemSelection}
                                            taxId={this.props.taxId}
                                            onChange={this.onBulkUpdateChange || function () { }}
                                            editable={true}
                                            title={'Settings '}
                                            type={this.getType()}
                                            documentType={this.getType()}
                                            containsBundleItems={this.selectionContainsBundleItem()}
                                        />
                                    </div>
                                    :
                                    <label className="mb-0">
                                        <a href={'#'} onClick={e => {
                                            e.preventDefault()
                                            this.triggerSelectAll(true)
                                        }}>
                                            <small>
                                                <FormattedMessage
                                                    id="common.listing.selectable.select_all"
                                                    defaultMessage="Select all items"
                                                />
                                            </small>
                                        </a>
                                    </label>
                                }
                            </div>
                        </div>
                    </div>
                }
                <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
                    <Droppable droppableId="groups" isDropDisabled={this.state.isGroupsDropDisabled}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                            >

                                {this.props.groups.map((g, index) => {
                                    return <PricingTableGroup
                                        tableId={this.props.tableId}
                                        mainObjectId={this.props.objectId}
                                        methods={methods}
                                        index={index}
                                        group={g}
                                        groupId={g.id}
                                        fromShowDetails={this.props.fromShowDetails}
                                        isLimitActive={this.props.isLimitActive}
                                        type={this.getType()}
                                        advice={this.findAdviceByItemId}
                                        triggerSelectAll={this.triggerSelectAll}
                                        onUpdate={onUpdateCallback || function () { }}
                                        onEditLinkClick={onEditLinkClickCallback}
                                        allItems={this.props.items}
                                        allowEdit={this.props.allowEdit}
                                        objectId={this.props.objectId}
                                        mainObject={this.props.mainObject}
                                        sortable={this.props.sortable}
                                        isDropDisabled={this.state.isDropDisabled}
                                        location={this.state.location}
                                        users={this.state.users}
                                        documentCalendarEvents={this.state.documentCalendarEvents}
                                        rowCustomStatuses={this.state.rowCustomStatuses}
                                        selectedItemSelectionSet={this.state.selectedItemSelectionSet}
                                        showInventoryDetails={this.state.showInventoryDetails}
                                        productDescription={ this.state.productDescription }
                                        stockDocument={this.state.stockDocument}
                                        documentStatus={this.state.documentStatus}
                                    />
                                })}
                            </div>

                        )}
                    </Droppable>
                    {this.state.main.length > 0 ? <div>
                        <div className={'border-bottom'}>
                            <Droppable droppableId="main" isDropDisabled={this.state.isMainDropDisabled}>
                                {(provided, snapshot) => (
                                    <div
                                        id={'#sortable-quote'}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className={"group-sortable " + (snapshot.isDraggingOver ? 'dnd-highlight' : '')}>
                                        {this.state.main.map((item, index) => {
                                            return <Draggable key={item.id} draggableId={item.id} index={index} isDragDisabled={!this.state.allowEdit}>
                                                {(provided, snapshot) => (
                                                    <div ref={provided.innerRef} {...provided.draggableProps}>
                                                        <PricingTableItemWrapper
                                                            tableId={this.props.tableId}
                                                            className={index === (this.state.main.length - 1) ? 'border-0' : ''}
                                                            advice={this.findAdviceByItemId(item.id)}
                                                            onUpdate={onUpdateCallback}
                                                            onEditLinkClick={ onEditLinkClickCallback }
                                                            isBundle={isBundle(item)}
                                                            key={item.id}
                                                            itemId={item.id}
                                                            groupId={""}
                                                            dragHandle={provided.dragHandleProps}
                                                            currency={this.props.currency}
                                                            type={this.getType()}
                                                            mainObjectId={this.props.objectId}
                                                            isLimitActive={this.props.isLimitActive}
                                                            fromShowDetails={this.props.fromShowDetails}
                                                            rowCustomStatuses={this.state.rowCustomStatuses}
                                                            showInventoryDetails={this.state.showInventoryDetails}
                                                            users={this.state.users}
                                                            {...this.state}
                                                            syncItemsWithCatalogPrices={this.props.syncItemsWithCatalogPrices || false}
                                                            stockDocument={this.state.stockDocument}
                                                            documentStatus={this.state.documentStatus}
                                                        />
                                                    </div>)}

                                            </Draggable>
                                        })}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                    </div> : ''}
                </DragDropContext>
            </div>

        );
    }
}
const mapState = (state, props) => {
    return {
        ...props,
        itemSelection: getPricingTableSelectedItems(state, props.objectId),
        items: getPricingTableItems(state),
        groups: getPricingTableGroups(state, props.objectId) || [],
        main: getMainItems(state) || [],
    }
}
const mapDispatch = (dispatch) => {
    return {
        dispatch
    }
}
export default connect(mapState, mapDispatch)(injectIntl(PricingTableContent))



// WEBPACK FOOTER //
// ./src/pricing/PricingTableContentComponent.jsx